import React, { useEffect, useState } from "react";
import { Container, Typography, Stack, useTheme } from "@mui/material";
import {
    termsContent,
    TermsContentSection,
    TermsContentType,
} from "../locales/terms";
import { getAppLanguage, getBrowserLanguage } from "../utils/languageUtils";
import { FullScreenLoader } from "./FullScreenLoader";

const Terms = () => {
    const theme = useTheme();

    const [lang, setLang] = useState<string>(getBrowserLanguage());
    const [terms, setTerms] = useState<TermsContentType | undefined>();

    useEffect(() => {
        if (window.Weglot) {
            const observer = new MutationObserver(() => {
                const wgLang = getAppLanguage();
                if (wgLang !== lang) setLang(wgLang);
            });

            observer.observe(document.documentElement, {
                attributes: true,
                attributeFilter: ["lang"],
            });

            return () => observer.disconnect();
        }
    }, [lang]);

    useEffect(() => {
        if (lang) setTerms(termsContent[lang] || termsContent["en"]);
    }, [lang]);

    if (!terms) return <FullScreenLoader />;

    return (
        <Container
            className="no-translation"
            maxWidth="md"
            sx={{
                padding: 3,
                borderRadius: "12px",
                bgcolor: theme.palette.background.paper,
                boxShadow: "0px 4px 17px rgba(0, 0, 0, 0.04)",
                textAlign: "left",
            }}
        >
            <Typography fontWeight={700} fontSize="24px" gutterBottom>
                {terms.title}
            </Typography>
            <Stack spacing={3}>
                {Object.entries(terms).map(([key, section]) =>
                    key !== "title" ? (
                        <Stack key={key} spacing={1}>
                            <Typography fontWeight={600} fontSize="18px">
                                {section.title}
                            </Typography>
                            {Array.isArray(section.text) ? (
                                (section as TermsContentSection).text.map(
                                    (item, index) => (
                                        <Typography
                                            key={index}
                                            fontSize="16px"
                                            color="text.secondary"
                                        >
                                            {item}
                                        </Typography>
                                    )
                                )
                            ) : (
                                <Typography
                                    fontSize="16px"
                                    color="text.secondary"
                                >
                                    {section.text}
                                </Typography>
                            )}
                        </Stack>
                    ) : null
                )}
            </Stack>
        </Container>
    );
};

export default Terms;
